import { Types } from "../types";
export var videoTypeFragmentSchema = Types.enum(["live", "vod"]);
//# sourceMappingURL=videoTypeFragment.js.map